<template>
  <div class="dropdown-wrapper">
    <!-- 触发元素（头像） -->
    <div class="trigger" ref="trigger" @click="toggle">
      <img :src="avatar" class="avatar" />
    </div>

    <!-- 下拉菜单 -->
    <div
      v-if="visible"
      class="dropdown"
      :style="style"
      ref="menu"
    >
      <!-- 小三角 -->
      <div class="arrow"></div>
      <slot></slot>
      <!--  -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: String
  },
  data() {
    return {
      visible: false,
      style: {},

    };
  },
  methods: {
    toggle() {
      this.visible ? this.hide() : this.show();
    },
    show() {
      const rect = this.$refs.trigger.getBoundingClientRect();
      this.style = {
        position: "fixed",
        top: rect.bottom + window.scrollY + 20 + "px",
        left: rect.left - (310)  + "px"
      };

      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    select(item) {
      this.$emit("select", item);
      this.hide();
    },
    logout() {
      this.$emit("logout");
      this.hide();
    },
    handleClickOutside(e) {
      if (
        !this.$refs.menu?.contains(e.target) &&
        !this.$refs.trigger.contains(e.target)
      ) {
        this.hide();
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.dropdown-wrapper {
  display: inline-block;
  position: relative;
  margin: 0 30px;
}

/* 头像 */
.avatar {
  border-radius: 50%;
  cursor: pointer;
}

/* 下拉菜单 */
.dropdown {
  width: 350px;
  background: var(--bg);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  padding: 10px 0;
  z-index: 9999;
  padding: 0 15px;
  height: auto;
}

/* 小三角 */
.arrow {
  position: absolute;
  top: -8px;
  right: 20px;
  width: 16px;
  height: 16px;
  background: var(--bg);
  transform: rotate(45deg);
  box-shadow: -2px -2px 5px rgba(0,0,0,0.1);
}


@media screen and (max-width: 768px) {
  .dropdown-wrapper {
    margin: 0 15px;
  }
}

</style>